module.exports = __webpack_public_path__ + "img/date.03c02f27.svg";